"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { ChevronRight } from "lucide-react";

export default function BreadcrumbLink() {
  const pathname = usePathname();
  
  // Only process if we're in the help section
  if (!pathname.startsWith("/help")) {
    return (
      <Link href="/help" className="hover:text-gray-700">
        Help Center
      </Link>
    );
  }

  // Split the path and remove empty strings
  const pathSegments = pathname.split("/").filter(Boolean);
  
  // Create breadcrumb items
  const breadcrumbs = pathSegments.map((segment, index) => {
    // Create the path for this breadcrumb
    const path = "/" + pathSegments.slice(0, index + 1).join("/");
    
    // Format the segment text
    const text = segment
      .split("-")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    // Special case for "help" to show as "Help Center"
    const displayText = segment === "help" ? "Help Center" : text;

    return {
      text: displayText,
      path
    };
  });

  return (
    <div className="flex items-center space-x-2">
      {breadcrumbs.map((crumb, index) => (
        <span key={crumb.path} className="flex items-center">
          {index > 0 && <ChevronRight className="w-4 h-4 mx-2 text-gray-400" />}
          <Link
            href={crumb.path}
            className={`hover:text-gray-700 ${
              index === breadcrumbs.length - 1 ? "text-gray-900" : "text-gray-600"
            }`}
          >
            {crumb.text}
          </Link>
        </span>
      ))}
    </div>
  );
}
